import { changeIntegrationRetentionPolicy } from 'actions/integrationSettings';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getIntegrationSettingsForm } from 'selectors/integrationSettings';
import { useSelector } from 'store';

const RetentionPolicy: React.FC = () => {
  const dispatch = useDispatch();

  const { email_chat_retention_policy: retentionPolicy } = useSelector(getIntegrationSettingsForm);

  const handleChangePolicy = (e: React.ChangeEvent<HTMLInputElement>): void => {
    dispatch(changeIntegrationRetentionPolicy(e.target.value));
  };

  return (
    <div className="flex flex-col gap-1 bg-white">
      <div className="flex flex-row">
        <span>What is your email and chat retention policy?</span>
        <span className="litlingo-red-color">*</span>
      </div>

      <div className="w-88">
        <input
          type="text"
          className="form-input h-8 w-88"
          value={retentionPolicy}
          onChange={handleChangePolicy}
        />
      </div>
    </div>
  );
};

export default RetentionPolicy;
